import React from 'react'
import {Descriptions, Divider} from "antd";
import OfferDetailTable from "./OfferDetailTable";
import userDateFormatter from "../../../services/formatters/userDateFormatter";

const OfferDetail = ({offer}) => {

    return (
        <React.Fragment>
            <div>
                <h3>Teklif Bilgileri</h3>
            </div>
            <Divider/>
            <div style={{marginBottom: '16px'}}>
                <Descriptions bordered>
                    <Descriptions.Item label={'Müşteri'}>{offer.bid.customer.name}</Descriptions.Item>
                    <Descriptions.Item label={'Firma Yetkilisi'}>{offer.bid.representative}</Descriptions.Item>
                    <Descriptions.Item
                        label={'Teklif Tarihi'}>{userDateFormatter(offer.bid.dateOfBid)}</Descriptions.Item>
                    <Descriptions.Item label={'Teslimat'}>{offer.bid.delivery}</Descriptions.Item>
                    <Descriptions.Item label={'Ödeme'}>{offer.bid.payment}</Descriptions.Item>
                    <Descriptions.Item label={'Not'}>{offer.bid.note}</Descriptions.Item>
                    <Descriptions.Item span={3} label={'Kur Bilgilendirmesi'}>{offer.bid.exchangeRate}</Descriptions.Item>
                    <Descriptions.Item span={3} label={'Teklif Durumu'}>  { offer.bid.bidStatus === 'WAITING' ? 'Beklemede' : offer.bid.bidStatus === 'NEGATIVE' ? 'Olumsuz' : 'Olumlu'}</Descriptions.Item>
                    {
                        offer.bid.rejectionReason.length ?
                            <Descriptions.Item label={'Olumsuzluk Nedeni'}
                                               span={3}>{offer.bid.rejectionReason}</Descriptions.Item>
                            : null
                    }
                </Descriptions>
            </div>
            <Divider/>
            <div>
                <OfferDetailTable offer={offer}/>
            </div>
        </React.Fragment>
    )
}
export default OfferDetail